import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import {Provider} from 'react-redux';
import * as serviceWorker from './serviceWorker';

import ErrorBoundary from './components/ErrorBoundary';
import App from './App';
import Routes from './routes';
import {loadApp} from './store/app/actions';
import store from './store';

ReactDOM.render(
	<Provider store={store}>
		<Router>
			<ErrorBoundary>
				<App>
					<Routes />
				</App>
			</ErrorBoundary>
		</Router>
	</Provider>,
	document.getElementById('root'),
);

store.dispatch(loadApp());

if (module.hot) {
	module.hot.accept();
}

serviceWorker.register();
